"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StockQuoteService = void 0;
class StockQuoteService {
    getQuotes(params) {
        if (!params) {
            return false;
        }
        return fetch('/ods.svc/getMarketQuotes', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'OData-Version': '4.0',
                consumer: 'id=A0056099-8CC7YJYS05J7L89Y;type=WEB'
            },
            body: JSON.stringify(params.data)
        })
            .then(res => res.json())
            .then(response => {
            if (!response?.value?.identifiers) {
                return {
                    response,
                    message: response?.error?.code || 'Unexpected response structure'
                };
            }
            if (response.value.identifiers.length !== params.data.symbol.length ||
                response.value.explanations !== null) {
                return {
                    response,
                    message: response.value.explanations ?? 'Unknown error'
                };
            }
            return {
                response: response.value.identifiers,
                message: 'success'
            };
        })
            .catch(error => {
            console.error(error);
            return {
                response: error,
                message: error.message
            };
        });
    }
}
exports.StockQuoteService = StockQuoteService;
